module.exports = __webpack_public_path__ + "assets/eml.png";